import "./index.css";
import { createRoot } from "react-dom/client";
import { App } from "./AppMain";

createRoot(document.getElementById("root")!).render(<App />);
